import React from "react";
import ChooseHandleDialog from "./components/Dialogs/ChooseHandleDialog";
import MigrateLiquidityDialog from "./components/Dialogs/MigrateLiquidityDialog";
import WalletConnectDialog from "./components/Dialogs/WalletConnectDialog";
import WrongNetworkDialog from "./components/Dialogs/WrongNetworkDialog";
import ZapDialog from "./components/Dialogs/ZapDialog";
import { useAppContext } from "./stores";
import { featureIsEnabled } from "./utils/features.utils";

export const Dialogs: React.FC = () => {
  const {
    state: { activeZapPool },
  } = useAppContext();

  return (
    <React.Fragment>
      <WalletConnectDialog />
      <ChooseHandleDialog />
      <WrongNetworkDialog />
      {featureIsEnabled("v3Contracts") && <MigrateLiquidityDialog />}
      {activeZapPool && <ZapDialog />}
    </React.Fragment>
  );
};
